import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},
	{
		path: '',
		loadChildren: () => import('@app/modules/public/public.module').then(m => m.PublicModule),
	},
	{
		path: 'punch-clock',
		loadChildren: () => import('@app/modules/punchUser/punchUser.module').then(m => m.PunchUserModule)
	},
	{
		path: 'home',
		loadChildren: () => import('@app/modules/home/home.module').then(m => m.HomeModule),
	},
	{
		path: '**',
		redirectTo: 'login',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {scrollPositionRestoration: 'disabled'}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
